import Alerts from 'lib/alerts';
import Cocktail from 'lib/Cocktail';

import modal from 'helpers/modal.js';
import loader from 'helpers/loader.js';

import BankAccountMixin from 'commons/viewMixins/BankAccount.js';
import FormView from 'commons/views/Form';
import RemovalModal from './RemovalModal';
import template from 'employer/templates/employee/PersonalInfo.ejs';
import childrenTemplate from 'employer/templates/employee/Children.ejs';
import countriesList from 'helpers/countriesList';
import moment from 'moment';

import {consts as EmployeeConsts} from 'newModels/employee.js';
import {payrollStatus} from 'newModels/payroll.js';
import Address from 'newModels/address.js';

// Mixins are listed at the bottom
module.exports = Cocktail.mixin(FormView.extend({
    events: function() {
        return Object.assign({}, FormView.prototype.events(), {
            'click .js-id-type-dropdown-menu a':   'updateIdType',
            'click .js-remove':                    'destroy',
            'click .js-remove-permanent':          'destroyPermanent',
            'click .js-restore':                   'restore',
            'click .js-remove-employee-user':      'removeEmployeeUser',
            'keyup input.js-ext-address':          'updateAddress',
            'change input.js-ext-address':         'updateAddress',
            'change select.js-ext-address':        'updateAddress',
            'change input.js-ext-idStr':           'updateIdStr',
            'change [name="childType"]':           'updateChildren',
            'change [name="pcbDeduction"]':        'updateChildren',
            'change select.js-ext-childrenAmount': 'toggleChildrenTypeSelect'
        });
    },

    initialize: function(options) {
        /* THIS PIECE OF CODE SHOULD NEVER RUN */
        if (this.model.get('marriedStatus') === 1 &&
        this.model.getChildrenCount()) {
            this.model.set('childrenAmount', '0');
            this.model.set('children', []);
        }
        /* END */

        this.options = Object.assign({
            template: template
        }, options || {});
        this.options.templateExtra =
            Object.assign({
                isNew:         this.options.isNew,
                model:         this.model,
                countriesList: countriesList,
                Address:       Address
            }, this.options.templateExtra || {});
        this.options.bankAccountOverrides = {companyId: app.company.id};

        this.removalModal = new RemovalModal({
            unsubmittedPayroll: this.options.unsubmittedPayroll,
            employee: this.model
        });

        return FormView.prototype.initialize.apply(this, [this.options]);
    },

    bindHandlers: function() {
        const r = FormView.prototype.bindHandlers.apply(this, arguments);

        this.model.on('change:isResident', this.toggleResidentSubType, this);
        this.model.on('change:isResident', this.togglePermanentResident, this);
        this.model.on('change:nationality', this.togglePermanentResident, this);
        this.model.on('change:idType', this.toggleIdMask, this);
        this.model.on('change:idType', this.toggleDob, this);
        this.model.on('change:idType', this.updateDobFromId, this);
        this.model.on('change:idType', this.updateGender, this);
        this.model.on('change:idStr', this.updateDobFromId, this);
        this.model.on(
            'change:residentSubType',
            this.onResidentSubTypeChange,
            this
        );
        // the delay is to prevent quick tabbing into the next field from
        // messing with updateGender()
        this.model.on(
            'change:idStr',
            () => setTimeout(this.updateGender.bind(this), 100),
            this
        );
        this.model.on('change:marriedStatus', this.toggleChildren, this);
        this.model.on(
            'change:marriedStatus',
            this.toggleIsSpouseDisabled,
            this
        );

        this.on('cancelled', this.scrollTop, this);

        if (this.removalModal) {
            this.removalModal.on('destroy', this.redirectToEmployeeList, this);
        }

        return r;
    },

    unbindHandlers: function() {
        const r = FormView.prototype.unbindHandlers.apply(this, arguments);

        this.model.off(null, null, this);
        this.off(null, null, this);

        if (this.removalModal) {
            this.removalModal.off(null, null, this);
        }

        return r;
    },

    toggleResidentSubType: function(model) {
        this.$('[name=residentSubType]').iCheck(
            model.get('isResident') === true ? 'enable' : 'disable'
        );
    },

    togglePermanentResident: function(model) {
        this.$('[name=isPermanentResident]').iCheck((
            (model.get('nationality') !== 'MY')
        ) ? 'enable' : 'disable');
    },

    // 20210207 hide isSpouseDisabled input for all marital statuses
    // except "Married and spouse is NOT working"
    // ticket: https://jibbletech.atlassian.net/browse/PPKAN-53
    toggleIsSpouseDisabled: function(model) {
        // show only for Married and spouse is NOT working
        if (model.get('marriedStatus') === 5) {
            this.$('[name=isSpouseDisabled]').iCheck('enable');
            this.$('#is-spouse-disabled-input').show();
        } else {
            this.$('[name=isSpouseDisabled]').iCheck('disable');
            this.$('#is-spouse-disabled-input').hide();
        }
    },

    toggleIdMask: function(model, value) {
        const isIcNumber = (
            (value || this.model.get('idType')) ===
                EmployeeConsts.ID_TYPE_IC_NUMBER
        );

        if (isIcNumber) {
            this.$('[name=idStr]').inputmask('999999-99-9999')
                .attr('placeholder', 'Enter IC Number')
                .val(!value ? this.model.get('idStr') : '');
            this.$('.js-idType-label').text('IC Number');
        } else {
            this.$('[name=idStr]').inputmask('*{*}')
                .attr('placeholder', 'Enter Passport')
                .val(!value ? this.model.get('idStr') : '');
            this.$('.js-idType-label').text('Passport');
        }
    },

    toggleDob: function(model, value) {
        const isIcNumber = (
            (value || this.model.get('idType')) ===
                EmployeeConsts.ID_TYPE_IC_NUMBER
        );

        this.$('input[name=dob]')
            .prop('disabled', isIcNumber)
            // the datepicker shows even if the field is disabled. I hide
            // the calendar button for that reason.
            .closest('.js-datepicker', this.el)
            .toggleClass('input-group', !isIcNumber)
            .find('.input-group-addon')
            .toggleClass('hidden', isIcNumber);
    },

    updateDobFromId: function(model) {
        // extracting dob from malaysian ic number, format:
        // https://en.wikipedia.org/wiki/National_Registration_Identity_Card_Number_(Malaysia)
        //

        let icNumber = model.get('idStr');
        let date;

        if (model.get('idType') !== EmployeeConsts.ID_TYPE_IC_NUMBER) {
            return;
        }

        if (/^\d{6,}/g.test(icNumber)) {
            if (parseInt(icNumber.substr(0, 2), 10) > 15) {
                icNumber = '19' + icNumber;
            } else {
                icNumber = '20' + icNumber;
            }

            date = moment(icNumber.substr(0, 8) + '+00:00', 'YYYYMMDDZ')
                .utcOffset(0);
            this.$('.js-datepicker').datepicker('setDate', date._d);
            this.$('.js-datepicker .js-datepicker-input').trigger('change');
        } else {
            this.$('.js-datepicker .js-datepicker-input')
                .val('').trigger('change');
        }
    },

    updateGender: function() {
        const idType = this.model.get('idType') || '';
        const isICNumber = idType !== EmployeeConsts.ID_TYPE_IC_NUMBER;
        const idStr = this.model.get('idStr') || '';
        const lastDigit = parseFloat(idStr.substr(-1));
        const isNotValidNumber = isNaN(lastDigit);

        if (isICNumber || isNotValidNumber) {
            return;
        }

        const isMale = lastDigit % 2 === 1;

        this.$('[name=gender][value="' + (isMale ? 1 : 2) + '"]')
            .iCheck('check');
    },

    /**
     * If residentSubType equals to 3(freelancer) ot 4(intern),
     * set EPF, EIS, SOCSO contribution to none as default
     */
    onResidentSubTypeChange: function(model, value) {
        if (value === EmployeeConsts.RESIDENT_SUBTYPE_FREELANCER) {
            this.model.set('isEpf', false);
            this.model.set('isEis', false);
            this.model.set('socsoCategory', EmployeeConsts.SOCSO_CATEGORY_NONE);
        }
    },

    toggleChildren: function(model) {
        const canHaveChildren = (
            model.get('marriedStatus') !==
                EmployeeConsts.MARRIED_STATUS_SINGLE
        );
        const hasChildren = (model.get('children') || []).length > 0;

        this.$('.js-ext-childrenAmount')
            .closest('.form-group')
            .toggleClass('hidden', !canHaveChildren);

        this.$('.js-ext-childType-container').closest('.form-group')
            .toggleClass('hidden', !canHaveChildren || !hasChildren);

        if (!canHaveChildren) {
            this.$('.js-ext-childrenAmount').val(0).trigger('change');
        }
    },

    toggleChildrenTypeSelect: function(ev) {
        const $el = this.$(ev.currentTarget);
        const childrenAmount = parseInt($el.val(), 10) || 0;
        let children = this.model.get('children') || [];
        for (let i = children.length; i < childrenAmount; i++) {
            children.push({
                category: 'underage',
                pcbDeduction: 100
            });
        }
        if (children.length > childrenAmount) {
            children = children.slice(0, (childrenAmount));
        }
        this.model.set('children', children);
        this.$('.js-ext-childType-container').html(childrenTemplate({
            model: this.model
        }));

        this.$('.js-ext-childType-container')
            .parent('.form-group').toggleClass('hidden', children.length === 0);
    },

    updateAddress: function(ev) {
        const $el = this.$(ev.currentTarget);
        const attr = $el.attr('name');
        const value = this.getInputValue($el);

        if (!this.model.getAddress()) {
            this.model.setAddress(new Address());
        }

        this.toggleError(attr);
        this.model.getAddress().set(attr, value);
    },

    updateIdStr: function(ev) {
        const $el = this.$(ev.currentTarget);
        const attr = $el.attr('name');
        const value = this.getInputValue($el);

        // anyway update the value so we could prevent object save with old data
        if (!this.model.set({'idStr': value})) {
            this.model.attributes.idStr = value;
            this.toggleError(attr, this.model.validationError.idStr[0]);
        }
    },

    updateChildren: function() {
        this.model.set('children', _.map(this.$('.js-ext-child'),
            function(child) {
                return {
                    category: this.getInputValue(
                        $(child).find('[name="childType"]')),
                    pcbDeduction: this.getInputValue(
                        $(child).find('[name="pcbDeduction"]'))
                };
            }.bind(this)));
    },

    updateIdType: function(ev) {
        const $el = this.$(ev.currentTarget);
        ev.preventDefault();

        this.model.set('idType', $el.data('value'));
    },

    render: function() {
        const r = FormView.prototype.render.apply(this, arguments);

        this.toggleIdMask();
        this.toggleIsSpouseDisabled(this.model);

        return r;
    },

    cancel: function(ev) {
        const $button = this.$(ev.currentTarget);
        const stopLoader = loader.startFullScreen($button);

        ev.preventDefault();

        this.model.setBankAccount(null);
        this.model.fetch()
            .then(() => this.model.fetchBankAccount())
            .then(() => this.model.fetchAddress())
            .then(() => this.model.trigger('sync'))
            .then(() => this.render)
            .finally(stopLoader);
    },

    dirty: function() {
        let tainted = this.tainted;

        if (!this.model.isNew()) {
            tainted = (
                this.model.dirty() || (
                    this.model.getBankAccount() &&
                        this.model.getBankAccount().dirty()
                ) || (
                    this.model.getAddress() &&
                        this.model.getAddress().dirty()
                )
            );
        }

        return tainted;
    },

    resetPayrollConfirm: function() {
        return new Promise((resolve, reject) => {
            if (!_.isObject(this.options.unsubmittedPayroll)) {
                return resolve(true);
            }

            Alerts.show('infoConfirm', {
                title: `Your saved payroll will be modified!`,
                text: `You have an unsubmitted payroll saved. \
                    If you continue, the payroll details of this employee \
                    will be updated based on the modifications you are about \
                    to save. Also, any unsaved payroll details will be lost.`,
                confirmButtonText: `Yes, Save Employee Information`
            }).then(() => resolve(), err => reject(err));
        });
    },

    save: function(ev) {
        const $el = this.$(ev.currentTarget);
        let stopLoader = () => {};

        if (!this.model.isValid()) {
            this.invalid(this.model, {errors: this.model.validationError});
            return;
        }

        this.resetPayrollConfirm().then(() => {
            stopLoader = loader.startFullScreen($el);

            const saveBankAccount = this.model.getBankAccount() ?
                this.model.getBankAccount().save() :
                Promise.resolve();

            return saveBankAccount
                .then(() => {
                    const address = this.model.getAddress();
                    if (address) {
                        if (address.isBlank()) {
                            this.model.setAddress(null);
                            return address.destroy();
                        }
                        return this.model.getAddress().save();
                    }
                    return Promise.resolve();
                })
                .then(() => {
                    const bankAccountId = this.model.getBankAccount() ?
                        this.model.getBankAccount().id :
                        null;
                    const addressId = this.model.getAddress() ?
                        this.model.getAddress().id :
                        null;

                    this.model.set('bankAccountId', bankAccountId);
                    this.model.set('addressId', addressId);
                    return this.model.save();
                })
                .then(() => (
                    this.options.isNew ?
                        app.company.fetch() :
                        Promise.resolve()
                ));
        }, () => Promise.reject({_cancelled: true})).then(() => {
            if (this.options.unsubmittedPayroll) {
                return this.options.unsubmittedPayroll
                    .resetEmployee({employee: this.model});
            }

            return Promise.resolve(true);
        }).then(() => {
            this.model.trigger('sync');

            if (this.options.isNew) {
                const nextStep = `employee/${this.model.id}\
                    /employmentDetails/isNew`;

                // Show message if first employee successfully saved
                if (app.company.get('employeeCount') === 1) {
                    Alerts.show('success', {
                        text: `Employee's Personal Info has been saved, \
                            proceed to Employment Details now`,
                        callback: () =>
                            app.mainRouter.navigate(nextStep, {
                                trigger: true,
                                replace: true
                            })
                    });
                }

                app.mainRouter.navigate(nextStep, {
                    trigger: true,
                    replace: true
                });
            } else {
                modal.showAlertSuccess(
                    `Employee's personal info has been saved`
                );
            }
        }).catch(err => {
            if ((err || {})._cancelled === true) {
                return;
            }
            Alerts.show('criticalError', err);
        }).finally(() => stopLoader());
    },

    destroy: function() {
        this.removalModal.show();
    },

    destroyPermanent: function() {
        return this.model.isDestroyable()
            .then(isDestroyable => {
                if (!isDestroyable) {
                    Alerts.show('error', {
                        title: `Can't delete this employee.`,
                        text:  `You can't delete this employee as he/she is part \
                            of a payroll.`,
                    });
                    return;
                } else {
                    Alerts.show('dangerConfirm', {
                        title: `Are you sure you want to permanently delete the employee?`,
                        confirmButtonText: `Yes, Delete`,
                        callback: isConfirm => {
                            if (!isConfirm) {
                                return;
                            }

                            this.model.permanentDestroy()
                                .then(() => app.company.fetchCurrentPayroll())
                                .then(payroll => {
                                    if (!payroll) {
                                        return false;
                                    }
                                    return payroll.setStatus(payrollStatus.INITIAL);
                                })
                                .then(() => {
                                    Alerts.show('success', {
                                        title: `Employee is successfully deleted`
                                    });

                                    app.mainRouter.navigate(
                                        'employees/archived', {trigger: true}
                                    );
                                })
                                .catch(err => {Alerts.show('criticalError', err);});
                        }
                    });
                }
            });
    },

    removeEmployeeUser: function() {
        const onRemove = () => {
            return this.model.removeEmployeeUser()
                .then(() => {
                    Alerts.show('success', {
                        title: `Employee User Removed!`
                    });

                    const $remove = this.$('.js-remove-employee-user');
                    $remove.hide();
                })
                .catch(err => {
                    Alerts.show('error', {
                        title: `Error Removing EmployeeUser`,
                        text:  err && err.message
                    });
                });
        };

        Alerts.show('dangerConfirm', {
            title: 'Remove Employee Access',
            text: `You're about to remove this employee's access.<br>\
                Please note this action is permanent.`,
            confirmButtonText: `Yes, Remove`,
            callback: isConfirm => {
                if (isConfirm) {
                    return onRemove();
                }
            }
        });
    },

    restore: function(e) {
        return this.resetPayrollConfirm()
            .then(() => {
                const stopLoader = loader.startFullScreen(e.target);
                return this.model.restore()
                    .then(employee => {
                        if (this.options.unsubmittedPayroll) {
                            return this.options.unsubmittedPayroll
                                .resetEmployee({employee})
                                .then(() => employee);
                        }

                        return employee;
                    })
                    .then(employee => {
                        app.company.fetch();
                        return employee;
                    })
                    .catch(err => { Alerts.show('criticalError', err); })
                    .finally(stopLoader);
            });
    },

    redirectToEmployeeList: function() {
        this.remove();
        app.mainRouter.navigate('employees', {trigger: true});
    },

    toggleError: function(attribute, message) {
        //FIXME custom messages can be set in the model, extending a view
        //method is not the place for this

        if (attribute === 'idStr' && message) {
            const type = (this.model.get('idType') === 1);
            message = type ? message.replace('Id str', 'IC Number') :
                message.replace('Id str', 'Passport');
        }

        FormView.prototype.toggleError.apply(this, [attribute, message]);
    },

    remove: function() {
        FormView.prototype.remove.apply(this, arguments);

        if (this.removalModal) {
            this.removalModal.remove();
            this.removalModal = undefined;
        }

        if (this.bankAccountModal) {
            this.bankAccountModal.remove();
            this.bankAccountModal = undefined;
        }
    },

    scrollTop: function() {
        window.scrollTo(0, 0);
    },

    // make sure that whenever we get the email field from the UI we make it
    // lower case
    getInputValueOfEmail: function($el) {
        return ($el.val() || '').trim().toLowerCase();
    }
}), BankAccountMixin);



// WEBPACK FOOTER //
// ./app/employer/views/employee/PersonalInfo.js